<template>
    <div>
        <div class="step first-step" v-if="firstStepVisible">
            <div class="img"></div>
            <div v-if="only" class="tips only">线上只有一个版本，不能回退了哦～</div>
            <div v-else>
                <div class="tips">版本回退后不可再次回退</div>
                <div class="tips warning">小程序可回退到上一个已发布的线上版本，且不可再次回退，版本回退即时生效</div>
            </div>
        </div>
        <div class="detail" v-if="secondStepVisible && !only">
            <div class="code">
                <img :src="preCodeUrl" class="qrcode" width="120">
            </div>
            <div><label class="label">版本号</label><span class="highlight">{{info.version}}</span></div>
            <div><label class="label">发布者</label><span>{{info.nickName}}</span></div>
            <div><label class="label">发布时间</label><span>{{formatDate(info.publishTime)}}</span></div>
            <div><label class="label">描述</label><span class="desc">{{info.description}}</span></div>
        </div>
    </div>
</template>
<script>
import formatDate from '@/lib/formatDate';
import dao from '@/lib/dao';
import Btn from '@/components/Button.vue';
export default {
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        },
        isProduct: {
            type: Boolean,
            default: false
        },
        preCodeUrl: {
            type: String,
            default: ''
        },
        firstStepVisible: {
            type: Boolean,
            default: false
        },
        secondStepVisible: {
            type: Boolean,
            default: false
        },
        only: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            appId: '',
            catList: []
        };
    },
    components:{
        Btn
    },
    methods: {
        formatDate(str) {
            return formatDate(new Date(str), 'yyyy-MM-dd HH:mm');
        },
        close () {
           this.$emit('close');
        },
        hideBody() {
            let popupBody = this.$refs.popupBody;
            if (popupBody && !popupBody.contains(event.target)) {
                this.$emit('close');
            }
        },
        nextStep() {
            this.$emit('nextStep')
        },
        submit() {
            
        }
    },
    mounted() {
        this.appId = this.$route.params.appId;
    }
}
</script>
<style lang="less" scoped>
.step {
    padding: 5px 5px 0px;
    color: #5C667E;
    text-align: center;
    font-size: 12px;
    .img {
        margin-top: 120px;
        padding-bottom: 40px;
        text-align: center;
        color: #5C667E;
        background: url(./../assets/icon_attention.png) center 0 no-repeat;
        background-size: 28px 28px;
    }
    .tips {
        font-family: PingFangSC-Medium;
        line-height: 14px;
        margin-bottom: 12px;
        font-size: 14px;
        &.warning {
            font-size: 12px;
            color: #9AA7C1;
            text-align: center;
            line-height: 18px;
            margin-bottom: 80px;
        }
        &.only {
            margin-bottom: 120px;
        }
    }
}
.detail {
    padding: 5px 5px 0px;
    color: #5C667E;
    > div {
        margin-bottom: 12px;
        padding-left: 87px;
        position: relative;
        min-height: 17px;
        line-height: 17px;
        .label {
            position: absolute;
            left: 0;
            display: inline-block;
            width: 77px;
            text-align: right;
        }
        .highlight {
            font-family: PingFangSC-Medium;
        	font-size: 14px;
        	font-weight: 400;
        }
        .desc {
            word-break: break-all;
        }
        &.cats {
            margin-bottom: 5px;
            .cat-container {
                display: inline-block;
                min-height: 12px;
                margin-right: -7px;
                &:empty {
                    margin-bottom: 7px;
                }
                .cat {
                    display: inline-block;
                    background-color: #EFF4FC;
                    border-radius: 2px;
                    padding: 2px 4px;
                    margin-right: 7px;
                    margin-bottom: 7px;
                }
            }
        }
    }
}
p {
    margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductPreVersionPopper.vue